import styled from 'styled-components';

const MessageBody = styled.div`
  line-height: 1.45;
  word-break: break-word;

  & p {
    margin: 0 0 8px;
  }

  & p:last-child {
    margin-bottom: 0;
  }

  & ul {
    margin: 0 0 8px;
    padding-left: 18px;
  }

  & ul:last-child {
    margin-bottom: 0;
  }

  & li {
    margin-bottom: 6px;
  }

  & li:last-child {
    margin-bottom: 0;
  }

  & strong {
    font-weight: 600;
  }
`;

export default MessageBody;
